import { testimonials } from '../../../mocks/testimonials';

export default function FeaturesTestimonials() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-xl mx-auto mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Social Proof</span>
          <h2 className="text-3xl font-black text-stone-900 mb-3 leading-tight">
            Real Business Owners, Real Results
          </h2>
          <p className="text-sm text-stone-500">
            See how small businesses are using each AdForge feature to save time, cut costs, and grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <article key={t.id} className="bg-stone-50 rounded-2xl border border-stone-100 p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <blockquote className="text-stone-600 text-xs leading-relaxed mb-5 italic">
                &ldquo;{t.content.slice(0, 140)}{t.content.length > 140 ? '…' : ''}&rdquo;
              </blockquote>
              <div className="flex items-center gap-2.5 mt-auto">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="text-xs font-bold text-stone-900">{t.name}</div>
                  <div className="text-xs text-stone-400">{t.business}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
